import React from "react";

import Paper from "@mui/material/Paper";
import Rating from "@mui/material/Rating";
import { Stack, Typography } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import ChatOutlinedIcon from "@mui/icons-material/ChatOutlined";
import Badge from "@mui/material/Badge";
import CollectionProducts from "../../../../components/CollectionDonationCard/CollectionProducts";
import { CollectionStatus, ComponentType } from "../../../../common/enum";
import ChatPanel from "../../../MessagePanel/ChatPanel";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import EventBusyIcon from "@mui/icons-material/EventBusy";
import MessageOutlinedIcon from "@mui/icons-material/MessageOutlined";
import {
  getCancelCollectionDonationById,
  getMyActiveDonation,
  setMyActiveDonationsLimit,
  setMyActiveDonationsOffset,
  setMyActiveDonationsPage,
} from "../../../DashBoardView/slice"
import {
  query,
  collection as firebaseCollection,
  where,
  getCountFromServer,
  collectionGroup,
  getDocs,
} from "firebase/firestore";
import { useDispatch, useSelector } from "react-redux";
import { db } from "../../../../firebase";
import { getRating } from "../../../DashBoardView/slice";
import {
  getDonorDetailById,
} from "../../../CreateCollection/slice";

const MOTIVE_STATUS = {
  cancel: CollectionStatus.cancelled,
  collected: CollectionStatus.collected,
};

const DonationCollectionCard = ({ collection, t }) => {
  const {
    auth: { profile },
  } = useSelector((state) => state);
  const dispatch = useDispatch();
  const [chatOpen, setChatOpen] = React.useState(false);
  const [rating, setRating] = React.useState({});
  const [unreadMessageCount, setUnreadMessageCount] = React.useState(0);
  const handleChat = React.useCallback(() => {
    setChatOpen(true);
  }, []);

  const toggleChatDrawer = React.useCallback((value) => {
    setChatOpen(value);
  }, []);

  React.useEffect(() => {
    const getData = async () => {
      const q = query(
        collectionGroup(db, "donationInfo"),
        where("collectionId", "==", collection?.collection.id)
      );
      const querySnapshot = await getDocs(q);
      querySnapshot.forEach(async (doc) => {
        const q = query(
          firebaseCollection(db, "chats", doc.data().chatUid, "messages"),
          where("isRead", "==", false),
          where("senderId", "!=", profile?.userId)
        );
        const snapshot = await getCountFromServer(q);
        setUnreadMessageCount(snapshot.data().count);
      });
    };
    getData();
  }, [collection, dispatch]);
  const STATUS_PRESENT = {
    cancelled: CollectionStatus.cancelled,
    collected: CollectionStatus.collected,
    expired: CollectionStatus.expired,
  };
  React.useEffect(() => {
    if (collection?.collection?.status === CollectionStatus.collected) {
      const data = {
        collectionId: collection?.collection.id,
      };
      dispatch(getRating(data))
        .unwrap()
        .then((res) => {
          if (res?.data) {
            setRating(res.data);
          }
        });
    }
  }, [dispatch, collection]);



  const backgroundStatusColor = React.useCallback((status) => {
    if (status === CollectionStatus.collected) {
      return "#37773e";
    } else if (status === CollectionStatus.cancelled) {
      return "#ff0000";
    } else {
      return "transparent";
    }
  }, []);
  return (
    <>
      <Paper variant="outlined" elevation={0} sx={{ m: 2, p: 1 }}>
        <Stack
          direction={"row"}
          alignItems={"center"}
          justifyContent={"space-between"}
        >
          <Stack direction={"column"}>
          <Typography
            variant="h6"
            color="text.secondary"
            textTransform={"capitalize"}
            marginTop={"16px"}
          >
            {"Código de reserva"}
          </Typography>
          <Typography varinat="body1" fontFamily={"Poppins"}  >
            {new Date(collection?.collection?.createdDate).getFullYear()}
            {collection?.collection?.id}
          </Typography>
          </Stack>
          <IconButton
            aria-label="chat-button"
            sx={{ mx: 3 }}
            onClick={handleChat}
          >
            <Badge color="primary" badgeContent={unreadMessageCount} max={99}>
              <ChatOutlinedIcon />
            </Badge>
          </IconButton>
        </Stack>
       
          <Stack direction={"column"}>
          <Typography
            variant="h6"
            color="text.secondary"
            textTransform={"capitalize"}
            marginTop={"16px"}
          >
            {"Recetor"}
          </Typography>
          <Typography varinat="body1" fontFamily={"Poppins"}  >
            {collection?.recetorEntity?.entityName}
          </Typography>
        </Stack>
        <Stack direction={"column"}>
          <Typography
            variant="h6"
            color="text.secondary"
            textTransform={"capitalize"}
            marginTop={"16px"}
          >
            {t("dateCollection")}
          </Typography>
          <Typography variant="body1"  >
           
            {new Date(collection?.collection.dateOfCollection).toLocaleString(
              "pt-PT",
              {
                day: "numeric",
                month: "numeric",
                year: "numeric",
                hour: "numeric",
                minute: "numeric",
                formatMatcher: "best fit",
              },
            )}
             
          </Typography>
        </Stack>
        {Object.values(MOTIVE_STATUS).includes(
          collection?.collection.status
        ) && (
          <Stack direction={"column"}>
            {/* <Typography variant="h6"  marginTop={"17px"}> */}
              {/* {t(`${collection?.collection.status.toLowerCase()}`)} */}
              {/* {CollectionStatus.collected && (
                                    <EventAvailableIcon />
                                  )}
            </Typography> */}
            <Typography
              variant="body1"
              fontFamily={"Poppins"}
              sx={{
                width: "fit-content",
                fontSize : "20px",
                marginTop:"16px",
                padding: 0.5,
                borderRadius: 0.5,
                color: "#fff",
                backgroundColor: backgroundStatusColor(
                  collection?.collection.status
                ),
              }}
            >
              {collection?.collection.status ===
                CollectionStatus.collected && (
                <EventAvailableIcon />
              )}
              {collection?.collection.status ===
                CollectionStatus.cancelled && (
                <EventBusyIcon />
              )}
              {t(
                `${Object.keys(STATUS_PRESENT).find(
                  (ite) =>
                    STATUS_PRESENT[ite] ===
                    collection?.collection.status
                )}`
              )}
            </Typography>
            <Typography
              variant="h6"
              color="text.secondary"
              textTransform={"capitalize"}
              marginTop={"16px"}
            >
              {t("feedback")}
            </Typography>
            {collection?.collection.status === CollectionStatus.collected && (
              <Rating
                name="read-only"
                value={rating ? Number(rating?.rating) : 0}
                readOnly
                marginTop={"16px"}
              />
            )}
            <Typography variant="body1"  marginTop={"16px"}>
              {collection?.collection.status === CollectionStatus.collected
                ? rating?.feedback
                : collection?.collection.motive}
            </Typography>
          </Stack>
        )}
         <Stack>
          {/* <Typography
            variant="h6"
            color="text.secondary"
            textTransform={"capitalize"}
            gutterBottom
            marginTop={"16px"}
          >
            {t("remarks")}
          </Typography>
          <Typography variant="body1"  marginTop={"16px"}>
              {collection?.collection.status === CollectionStatus.collected
                ? rating?.feedback
                : collection?.collection.motive}
            </Typography> */}

        </Stack>
        {collection?.collectionProducts?.legth > 0 && 
        <Stack>
          <Typography
            variant="h6"
            color="text.secondary"
            textTransform={"capitalize"}
            gutterBottom
            marginTop={"16px"}
          >
            {t("Articles")}
          </Typography>
          <CollectionProducts
           marginTop={"16px"}
            products={collection?.collectionProducts}
            t={t}
            componentType={ComponentType.AGENDA_PRODUCT}
          />
        </Stack>}
      </Paper>
      <ChatPanel
       marginTop={"16px"}
        collection={collection}
        chatdrawerState={chatOpen}
        toggleChatDrawer={toggleChatDrawer}
        t={t}
      />
    </>
  );
};

export default DonationCollectionCard;
